/* eslint-disable */
import 'whatwg-fetch';
import Cookies from 'js-cookie';
import QueryString from 'query-string';
import Browser from "./browser";
import { getYSFOpenid, getSignToken, getPreviewAuth, getExamToken, getAdjustLeaveToken } from "./authUtil";
import { getQrOpenid } from './util.js';
import { ERRORS } from './Consts';

const defaultApiPath = '/api';

const METHOD = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
};

const CONTENT_TYPE = {
  FORM_URLENCODE: 'application/x-www-form-urlencoded',
  FORM_DATA: 'application/formdata',
  JSON: 'application/json',
};

const CONTENT_TYPE_KEY = 'Content-Type';

class BaseModelCore {
  constructor(url) {
    this.url = url;
  }

  /**
   * 创建fetch参数
   * @param {JSONObject} options
   */
  createOptions(options = {}) {
    let { data, headers, method } = options;
    data = data || {};
    headers = headers || {};
    method = method || METHOD.GET;

    let body = '';

    if (options.emulateJSON) {
      headers[CONTENT_TYPE_KEY] = CONTENT_TYPE.FORM_URLENCODE;
      body = QueryString.stringify(data);
    } else if (
      method === METHOD.POST ||
      method === METHOD.PUT ||
      method === METHOD.PATCH ||
      method === METHOD.DELETE
    ) {
      headers[CONTENT_TYPE_KEY] = CONTENT_TYPE.JSON;
      body = JSON.stringify(data || {});
    }
    const token = Cookies.get('token');
    const signToken = getSignToken();
    const examToken = getExamToken();
    const adjustLeaveToken = getAdjustLeaveToken();
    const isSign = window.location.href?.indexOf('/signUp') > -1 || window.location.href?.indexOf('/signup') > -1;
    const isExam = window.location.href?.indexOf('/exam') > -1;
    const isAdjustLeave = window.location.href?.indexOf('/adjustLeave') > -1;
    const previewAuth = getPreviewAuth();

    if (token || signToken || previewAuth || examToken || adjustLeaveToken) {
      headers['Authorization'] = isSign ? (
        previewAuth || signToken
      ) : (
        isExam || isAdjustLeave ? (
          previewAuth || examToken || adjustLeaveToken
        ) : (
          token
        )
      );
    }
    console.log(isSign, isAdjustLeave, previewAuth, adjustLeaveToken, examToken, isExam, headers, window.location.href)
    if (Browser.ysfMiniprogram) {
      headers['channel'] = 101;
      const ysfOpenid = getYSFOpenid();
      if (ysfOpenid) {
        headers['openId'] = ysfOpenid;
      }
    }
    if (Browser.wxMiniprogram) {
      headers['QrOpenId'] = getQrOpenid();
    }
    const retVal = {
      mode: 'cors',
      credentials: 'include',
      body: null,
      ...options,
      method,
      headers,
    };

    if (method !== METHOD.GET) {
      retVal.body = body;
    }

    return retVal;
  }

  /**
   * 执行请求 仅仅处理返回值为json的请求
   * @param {Object} options
   */
  async execute(options = {}) {
    let url = options._url || this.url;
    try {
      const tmpOptions = {
        method: 'GET',
        credentials: 'include',
        headers: {},
        emulateJSON: false,
        // 是否统一处理 error
        showError: true,
        apiPath: defaultApiPath,
        data: {},
        ...options,
      };

      const _options = this.createOptions(tmpOptions);
      if (tmpOptions.method === METHOD.GET) {
        const param = QueryString.stringify(tmpOptions.data);
        url = param ? `${url}?${param}` : url;
      }

      const path = /^http/.test(url) ? url : `${url}`.replace(/\/{2}/g, '/');
      const response = await fetch(path, _options);
      const { status, headers } = response;
      let result;
      if (status === 200) {
        if (
          headers.get(CONTENT_TYPE_KEY) &&
          headers.get(CONTENT_TYPE_KEY).toLowerCase().indexOf(CONTENT_TYPE.JSON) >= 0
        ) {
          result = await response.json();
          if (result.result) {
            result.dataMap = result.result;
            delete result.result;
          }
          if (`${result.code}` !== '200') {
            result.status = status;
            throw result;
          }
        } else {
          // 返回JSON以外字符, 出错
          result = {
            status,
            code: 200501,
            message: '返回数据类型错误, 应该返回JSON格式数据, 请联系管理员',
            type: ERRORS.ERROR_500,
          };
          throw result;
        }
      } else {
        // 异常处理
        result = {
          code: status,
          status,
        };
        let tmpResult = {};
        switch (status) {
          case 401:
            tmpResult = {
              message: '请登录后再试.',
              type: ERRORS.ERROR_401,
            };
            break;
          default:
            tmpResult = {
              message: '服务端通信出错,请与管理员联系.',
              type: ERRORS.ERROR_500,
            };
        }
        Object.assign(result, tmpResult);
        throw result;
      }
      const tmpHeaders = {};
      const ret = {
        ...result,
        result,
        response: {
          headers: tmpHeaders,
          headerDate: headers.get('Date'),
          status,
        },
      };
      return ret;
    } finally { }
  }
}

class RestModelCore extends BaseModelCore {
  execute(options) {
    const that = this;
    const _options = { data: {}, ...options };
    if (_options.data.id) {
      _options._url = `${that.url}/${_options.data.id}`;
      delete _options.data.id;
    }
    return super.execute(_options);
  }

  /**
   * 查询
   * @param params 参数
   * @param options 配置
   */
  async get(params = {}, options = {}) {
    const that = this;
    const _options = {
      ...options,
      method: METHOD.GET,
      data: params,
    };
    return that.execute(_options);
  }

  /**
   * 新增
   * @param params 参数
   * @param options 配置
   */
  async post(params, options = {}) {
    const that = this;
    const _options = {
      ...options,
      method: METHOD.POST,
      data: params,
    };
    return that.execute(_options);
  }

  /**
   * 更新
   * @param params 参数
   * @param options 配置
   */
  async put(params, options = {}) {
    const that = this;
    const _options = {
      ...options,
      method: METHOD.PUT,
      data: params,
    };
    return that.execute(_options);
  }

  /**
   * 更新部分字段
   * @param params 参数
   * @param options 配置
   */
  async patch(params, options = {}) {
    const that = this;
    const _options = {
      ...options,
      method: METHOD.PATCH,
      data: params,
    };
    return that.execute(_options);
  }

  /**
   * 删除
   * @param params 参数
   * @param options 配置
   */
  async delete(params, options = {}) {
    const that = this;
    const _options = {
      ...options,
      method: METHOD.DELETE,
      data: params,
    };
    return that.execute(_options);
  }
}

class QueryModelCore extends BaseModelCore {
  /**
   * 查询Get方式
   * @param params 参数
   * @param options 配置
   */
  async get(params = {}, options = {}) {
    const _options = { ...options, method: METHOD.GET };

    if (params) {
      _options.data = params;
    }

    return super.execute(_options);
  }

  /**
   * 查询Post方式
   * @param params 参数
   * @param options 配置
   */
  async post(params = {}, options = {}) {
    const _options = { ...options, method: METHOD.POST };

    if (params) {
      _options.data = params;
    }
    return super.execute(_options);
  }
}

export { QueryModelCore, METHOD };

export default RestModelCore;
